module.exports = __webpack_public_path__ + "img/custom-web-development-listing.d705147c.jpg";